import { useFeriadoSalvar } from "@/Services/geral/data/FeriadoService";
import { Button, Flex, Form } from "antd";
import FeriadoFormBasic, { type IFeriadoFormBasicProps, type IFeriadoFormBasicRef, type IFeriadoFormType } from "./FeriadoFormBasic";
import { useCallback, useRef } from "react";

type FeriadoParametrosType = Parameters<typeof useFeriadoSalvar>[0];
type ButtonOnClickType = NonNullable<Parameters<typeof Button>[0]["onClick"]>;

export interface IFeriadoFormProps extends IFeriadoFormBasicProps {
    onCancelar ?: ButtonOnClickType;
    onSuccess?:FeriadoParametrosType["onSuccess"],
    /** * @default true */
    renderizarAcoes ?: boolean;
}

export default function FeriadoForm({
    form : formParam,
    onSuccess,
    onCancelar : onCancelarParam,
    renderizarAcoes,
    ...rest
}:IFeriadoFormProps) {
    renderizarAcoes = renderizarAcoes ?? true;

    const refForm = useRef<IFeriadoFormBasicRef|null>(null);
    const [newForm] = Form.useForm<IFeriadoFormType>();
    const form = formParam ?? newForm;
    
    const onCancelar = useCallback<ButtonOnClickType>((e) => {
        form?.resetFields();

        onCancelarParam?.(e);
    }, [onCancelarParam]);

    const {
        isPending,
        mutate
    } = useFeriadoSalvar({
        onSuccess(data, variables, context) {
            onSuccess?.(data, variables, context)
        }
    });

    return <div>
        <FeriadoFormBasic
            {...rest}
            form={form}
            ref={refForm}
            initialValues={{}}
            onFinish={(values) => {
                mutate(values.feriado);
            }}
        />
        {renderizarAcoes && <Flex gap="small" wrap="wrap" justify="center">
            <Button type="primary" danger htmlType="reset" onClick={(e) => { onCancelar?.(e) }}>
                Cancelar
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
                Salvar
            </Button>
        </Flex>}
    </div>;
}